module.exports = __webpack_public_path__ + "static/media/sg11cr538.25111b73.png";